import React from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

function Intro() {
  return (
    <>
      <Typography variant="h4">Introduction</Typography>

      <Typography variant="body1" component="div">
        <p>Often people wonder what their security budget should be. A budget can be a good indication of your
          commitment to security. Follow the steps in this simple wizard to get a few budget estimates.
        </p>
        <p>
          It is a companion tool for our <Link href="https://securityprogram.io/blog/security-budgets">article</Link>
          &nbsp;about security budgets. For more information, reach out to us at&nbsp;
          <Link href="mailto:info@securityprogram.io">info@securityprogram.io</Link>
        </p>
        <p>Note: This tool only runs in your browser. No data is stored.</p>
      </Typography>
    </>
  );
}

export default Intro;
